export default function (str: string, days: number) {
  var myDate = new Date(str);
  myDate.setDate(myDate.getDate() + days);
  return myDate.toISOString();
}
